module.exports = __webpack_public_path__ + "static/media/defaultBG.fce09908.jpg";